import {
  ENTITY_TYPE_PARAMETER,
  LABELS_PARAMETER,
} from "helpers/constants/miscellaneous";
import { trackFilterSelection } from "helpers/utility/amplitude";
import { useSelector } from "react-redux";
import { FilterOption, isValidEntityType } from "types";
import MultiSelectDropDown from "views/pages/DataPage/CardsView/DataPageFilters/MultiSelectDropDown";
import FilterButton from "views/atomComponents/FilterButton";
import useUpdateQueryParameter from "hooks/useUpdateQueryParameter";
import { getEntityTypeFilter } from "redux/SingleDataset/selectors";
import { getDatasetContextualLabels } from "redux/SingleDataset/selectors";
import { State } from "redux/store";
import useQueryParam from "hooks/useQueryParam";
const DataPageLabelFilters = () => {
  const updateQueryParameter = useUpdateQueryParameter();
  const labelFromQueryParam = JSON.parse(
    useQueryParam(LABELS_PARAMETER) || "[]"
  );
  const datasetLabels = useSelector((state: State) =>
    getDatasetContextualLabels(state, labelFromQueryParam)
  );
  const handleClearLabels = () => {
    const unselectedLabels = datasetLabels.map((option: FilterOption) => ({
      ...option,
      selected: false,
    }));
    updateQueryParameter(unselectedLabels, LABELS_PARAMETER);
  };
  const selectedLabels = datasetLabels.filter(
    (option: FilterOption) => option.selected
  );
  const isLabelSelected = selectedLabels.length > 0;
  const selectedLabelsId = selectedLabels.map(
    (option: FilterOption) => option.id
  );
  const selectedLabelsText = selectedLabels.map(
    (option: FilterOption) => option.text
  );
  const firstLabelText =
    selectedLabelsText.length > 0 ? selectedLabelsText[0] : "";
  const labelsCountDisplayNumber =
    selectedLabels?.length > 1 ? selectedLabels?.length - 1 : 0;

  const entityParam = useQueryParam(ENTITY_TYPE_PARAMETER);
  const entityTypeFromQueryParam = isValidEntityType(entityParam)
    ? entityParam
    : null;
  const entityTypeFilter = useSelector((state: State) =>
    getEntityTypeFilter(state, entityTypeFromQueryParam)
  );

  const handleFilterSelection = (value: number) => {
    const selectedLabel = datasetLabels.find(
      (option: FilterOption) => option.id === value
    );

    if (selectedLabel?.selected) {
      trackFilterSelection("Labels", "Dataset", entityTypeFilter, "Removed");
    } else {
      trackFilterSelection("Labels", "Dataset", entityTypeFilter, "Added");
    }

    const newDatasetLabels = [
      ...datasetLabels.filter((option: FilterOption) => option.id !== value),
      { ...selectedLabel, selected: !selectedLabel?.selected },
    ];

    updateQueryParameter(newDatasetLabels as any, LABELS_PARAMETER);
  };

  return (
    <FilterButton
      label={"Labels"}
      selectedLabel={firstLabelText}
      variant={isLabelSelected ? "selected" : "default"}
      itemCount={labelsCountDisplayNumber}
      tooltip={`Apply this filter to display only the data entries tagged with a specific Image or Object Label you're interested in.`}
    >
      <MultiSelectDropDown
        items={datasetLabels}
        selectedItemsIds={selectedLabelsId}
        onClearSelection={handleClearLabels}
        onItemSelection={handleFilterSelection}
      />
    </FilterButton>
  );
};

export default DataPageLabelFilters;
